// src/components/Overview.js
import React, { useState, useEffect } from "react";

import axios from "axios";
import { BASE_URL, security_key } from "../../global";

const Overview = () => {
    const [loading, setLoading] = useState(false);
    const [totalMembers, setTotalMembers] = useState(0);
    const [paidMembers, setPaidMembers] = useState(0);
    const [freeMembers, setFreeMembers] = useState(0);

    useEffect(() => {
        getAdminDashboardStatistics();
    }, []);

    const getAdminDashboardStatistics = async () => {
        try {
            setLoading(true);

            const response = await axios.post(`${BASE_URL}API/apicall`, {
                security_key,
                mode: "getAdminDashboardStatistics",
                pk_user_key: sessionStorage.getItem("pk_user_key"),
            });

            const output = response.data;
            if (Object.keys(output).length > 0) {
                setTotalMembers(output["totalMembers"]);
                setPaidMembers(output["paidMembers"]);
                setFreeMembers(output["freeMembers"]);
            } else {
                console.error("Oops! Something went wrong.");
            }
        } catch (error) {
            console.error("Error adding article: " + error.message);
        } finally {
            setLoading(false);
        }
    };
    return (
        <div className="overview">
            <div className="row gx-2">
                <div className="col-md-12 col-lg-4 p-0  mb-3">
                    <div className="head-box-admin p-3 d-flex">
                        <div className="box"></div>
                        <div className="box px-2 my-auto">
                            <div className="text-box">
                                <p>Total Members</p>
                                <span className="head-box-count">{totalMembers}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-12 col-lg-4 p-0  mb-3">
                    <div className="head-box-admin p-3 d-flex">
                        <div className="box"></div>
                        <div className="box px-2 my-auto">
                            <div className="text-box">
                                <p>Paid Members</p>
                                <span className="head-box-count">{paidMembers}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-12 col-lg-4 p-0  mb-3">
                    <div className="head-box-admin p-3 d-flex">
                        <div className="box"></div>
                        <div className="box px-2 my-auto">
                            <div className="text-box">
                                <p className="mb-1">Free Members</p>
                                <span className="head-box-count">{freeMembers}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <style jsx>
                {`
                    .head-box-admin {
                        width: 97%;
                        height: 100%;
                        background-color: #ffffff !important;
                        border: 1px solid #e7e7e7 !important;
                        box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
                        border-radius: 6px;
                    }
                `}
            </style>
        </div>
    );
};

export default Overview;
